import { Component, Input } from '@angular/core';

import { TableLink } from '../shared/models';

/**
 * Link displayed in <app-table>
 *
 * 2 display modes :
 * - "open in current tab" (blue bold link)
 * - "open in new tab" (black bold text + blue icon link)
 *
 * The behaviour is not managed in this component, but in the function passed in parameter.
 */
@Component({
  selector: 'app-table-link',
  templateUrl: './table-link.component.html',
  styleUrls: ['./table-link.component.scss'],
})
export class TableLinkComponent {
  @Input() link: TableLink;
}
